import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-to",
  "use": "icon-icon-to-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-to\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#c10000\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#fff\" d=\"M0 0h218.3v175H0z\" />\n    <g fill=\"#c10000\">\n      <path d=\"M89.8 27.3h34.8v121.9H89.8z\" />\n      <path d=\"M168.2 70.8v34.8H46.3V70.8z\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol